<router-outlet><ngx-spinner
    bdColor="rgba(0, 0, 0, 0.8)"
    size="medium"
    color="#fff"
    type="ball-scale-multiple"
    [fullScreen]="true"
>
    <span style="color: white">{{ 'LOADING' | translate }}...</span>
</ngx-spinner></router-outlet>
